import { render, staticRenderFns } from "./PointSelectDetail.vue?vue&type=template&id=276ce9e8&scoped=true"
import script from "./PointSelectDetail.vue?vue&type=script&lang=js"
export * from "./PointSelectDetail.vue?vue&type=script&lang=js"
import style0 from "./PointSelectDetail.vue?vue&type=style&index=0&id=276ce9e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ce9e8",
  null
  
)

export default component.exports